import { Box, Button } from "@mui/material";
import { useState } from "react";
import { useOrganizationSecrets } from "../hooks/useOrganizationSecrets";
import { useOrganizationVariables } from "../hooks/useOrganizationVariables";
import { EmptyTable } from "../molecules/EmptyTable";
import { APITable } from "../organisms/APITable";
import { OrganizationSecretDetailsModal } from "../organisms/modals/OrganizationSecretDetails";
import { OrganizationVariableDetailsModal } from "../organisms/modals/OrganizationVariableDetails";
import {
  organizationListFilterOptions,
  organizationSecretsListColumnsVisibility,
  organizationVariablesListColumnsVisibility,
} from "../utilities/columns-visibility/OrganizationVariablesListColumnsVisibility";

export const OrganizationSettingsEnvironment = () => {
  const [selectedVariable, setSelectedVariable] = useState<string | null>(null);
  const [openVariableModal, setOpenVariableModal] = useState<boolean>(false);
  const [selectedSecret, setSelectedSecret] = useState<string | null>(null);
  const [openSecretModal, setOpenSecretModal] = useState<boolean>(false);
  return (
    <Box display="flex" flexDirection="column" paddingBottom="80px" paddingTop="20px" gap="20px">
      <OrganizationVariableDetailsModal
        objectId={selectedVariable}
        open={openVariableModal}
        onClose={() => {
          setOpenVariableModal(false);
          setSelectedVariable(null);
        }}
      />
      <OrganizationSecretDetailsModal
        objectId={selectedSecret}
        open={openSecretModal}
        onClose={() => {
          setOpenSecretModal(false);
          setSelectedSecret(null);
        }}
      />
      <APITable
        title="Variables"
        hideColumnVisibility
        useGetData={useOrganizationVariables}
        queryParams={{}}
        columnsVisibility={organizationVariablesListColumnsVisibility}
        filterOptions={organizationListFilterOptions}
        rowOnClick={(objVar) => {
          setSelectedVariable(objVar.id);
          setOpenVariableModal(true);
        }}
        secondComponent={<Button onClick={() => setOpenVariableModal(true)}>Create</Button>}
        emptyTableComponent={
          <EmptyTable label="Environment Variables" description="No variables added yet." />
        }
        tableSize="small"
        smallEmptyHeight
        displayTags={false}
      />
      <APITable
        title="Secrets"
        hideColumnVisibility
        useGetData={useOrganizationSecrets}
        queryParams={{}}
        columnsVisibility={organizationSecretsListColumnsVisibility}
        filterOptions={organizationListFilterOptions}
        rowOnClick={(secret) => {
          setSelectedSecret(secret.id);
          setOpenSecretModal(true);
        }}
        secondComponent={<Button onClick={() => setOpenSecretModal(true)}>Create</Button>}
        emptyTableComponent={
          <EmptyTable label="Environment Secrets" description="No secrets added yet." />
        }
        tableSize="small"
        smallEmptyHeight
        displayTags={false}
      />
    </Box>
  );
};

export default OrganizationSettingsEnvironment;
